var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercedesBenzWhiteLogoResized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 153",
    style: {
      enableBackground: "new 0 0 288 153"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mercedes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MERCEDES",
    transform: "translate(-74.000000, -74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mercedes",
    transform: "translate(74.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3524",
    className: "st0",
    d: "M172,8.7c24.4,12.8,41,38.3,41,67.8s-16.6,55.1-41,67.8v-8.8c9.3-5.6,17.2-13.4,22.9-22.6 l-22.9-9.3V89.4l25.2,19.7c5.3-9.7,8.2-20.8,8.2-32.6c0-25-13.4-46.9-33.4-59V8.7z M136.6,0c12.7,0,24.8,3.1,35.4,8.7v8.8 c-9.8-5.9-21.3-9.4-33.4-9.8l8.8,62.6L172,89.4v14.2l-35.6-14.4l-35.3,14.5V89.6l24.8-19.3l8.7-62.6c-12.3,0.4-23.6,3.9-33.4,9.8 V8.7C111.7,3.1,123.8,0,136.6,0z M172,144.3c-10.7,5.6-22.7,8.7-35.4,8.7c-12.8,0-24.9-3.2-35.5-8.7v-8.8 c10.3,6.3,22.5,9.9,35.5,9.9c12.9,0,25-3.6,35.4-9.9V144.3z M101.1,144.3C76.6,131.5,60,105.9,60,76.5s16.6-55,41.1-67.8v8.8 c-20.1,12.1-33.4,34-33.4,59c0,11.9,3,23.1,8.3,32.8l25.2-19.7v14.1l-22.8,9.4c5.7,9.2,13.5,16.9,22.8,22.4V144.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercedesBenzWhiteLogoResized);
export default __webpack_public_path__ + "static/media/Mercedes-benz-white-logo-resized.a91a397690ec0901beb7d3c6512e7e72.svg";
export { ForwardRef as ReactComponent };